module.exports = __webpack_public_path__ + "assets/img/1206px蘑菇小兵详情页.c2891713.jpg";